<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <list :edit="edit" @form="dialog = true" @edit="onEdit" />
        <form-manager
          ref="form"
          :dialog="dialog"
          :stadium-id="stadiumId"
          :edit="edit"
          @close="onClose"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FormManager from './FormManager'
import List from './List'
export default {
  name: 'Cameras',
  components: {
    List,
    FormManager,
  },
  props: {
    stadiumId: {
      type: String,
      default: '',
      required: false,
    },
    stadiumView: {
      type: Boolean,
      default: false,
      required: false,
    },
    edit: {
      type: Boolean,
      default: true,
      required: false,
    },
    cameraId: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  mounted() {
    this.$store.dispatch('cameras/resetState')
    this.initData()
    if (!this.stadiumView && this.cameraId) this.openCamera(this.cameraId)
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
  },
  methods: {
    ...mapActions({
      fetchCameras: 'cameras/fetchList',
      fetchStadiums: 'stadiums/fetchSelectList',
      fetchOne: 'cameras/fetchOne',
      setStatus: 'events/setStatus',
    }),
    async initData() {
      // this.resetPagitations()

      if (!this.stadiumView) {
        this.fetchStadiums()
        await this.fetchCameras()
      }
    },
    onEdit(id) {
      // Embedded inside the stadium view: keep the dialog local, no routing.
      if (this.stadiumView) {
        this.openCamera(id)
        return
      }
      if (this.$route.params.cameraId !== id) {
        this.$router
          .push({ name: 'cameras', params: { cameraId: id } })
          .catch(() => {})
      }
    },
    onClose() {
      this.dialog = false
      if (!this.stadiumView && this.$route.params.cameraId) {
        this.$router.push({ name: 'cameras' }).catch(() => {})
      }
    },
    async openCamera(id) {
      if (this.$refs.form) this.$refs.form.clear()
      await this.fetchOne(id)
      this.dialog = true
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    },
    stadiumId(val) {
      if (val) {
        this.fetchCameras({ stadiumId: val })
      }
    },
    cameraId(id) {
      if (this.stadiumView) return
      if (id) this.openCamera(id)
      else this.dialog = false
    },
  },
}
</script>
